export default __webpack_public_path__ + "static/media/po.168324ad.svg";